import { useMemo } from 'react';
import { generatePath, useNavigate } from 'react-router';

import { PATHS } from '@/shared/config';
import { useAppSelector } from '@/shared/hooks';
import { trackEvent } from '@/shared/lib';

import { albumModel } from '@/entities/album';

export const useDentalPhotoReportCard = (patientID: string) => {
  const navigate = useNavigate();
  const albums = useAppSelector(albumModel.selectors.selectAll);

  const latestAlbum = albums[0];

  const photos = useMemo(() => {
    return albums.flatMap((album) => album.StudyAssetIDs);
  }, [albums]);

  const lastUploadDate = latestAlbum?.Time?.toDate();

  const hasPhotos = photos.length > 0;

  const handleCardClick = () => {
    trackEvent({
      eventName: 'PatientsPageDentalPhotosWidgetClicked',
    });

    navigate(
      generatePath(PATHS.dentalPhotos, {
        patientID,
      }),
    );
  };

  return {
    photos,
    lastUploadDate,
    hasPhotos,
    handleCardClick,
  };
};
